import {
  SET_USER,
  SET_SETTINGS,
  SET_LOADING_ITEM,
  REMOVE_LOADING_ITEM,
  SET_ERROR_ITEM,
  REMOVE_ERROR_ITEM,
  SET_COMMON_DATA,
  SET_SHOW_BANNERS,
  POP_PROFILE,
  IS_PRODUCTION,
} from '@constants';
import { getProfile } from '@modules/get-data';
import { BANNERS_OPTIONS } from '@constants/params';
import { Cookie } from '@libs';
import { BANNERS } from '../constants';

export const setUser = () => async (dispatch, getState) => {
  const {
    settings: { getCtx },
  } = getState();

  try {
    const profile = await dispatch(getProfile());

    const { id, name, email, currency, tariff = {} } = profile;
    const payload = {
      id,
      name,
      email,
      currency,
      tariff: {
        name: tariff.name,
        alias: tariff.alias,
      },
    };
    const secure = IS_PRODUCTION;
    const maxAge = 14 * 86400;
    const path = '/';

    // Добавляется для Аналитики (Analytics.js)
    Cookie.set(getCtx(), POP_PROFILE, JSON.stringify(payload), { maxAge, secure, path });
    dispatch({ type: SET_USER, payload });
  } catch (e) {
    dispatch({ type: SET_USER, payload: null });
  }
};

export const setSettings = (settings) => ({ type: SET_SETTINGS, payload: settings });

export const removeUser = () => ({ type: SET_USER, payload: null });

export const startLoading = (item) => ({ type: SET_LOADING_ITEM, payload: item });
export const endLoading = (item) => ({ type: REMOVE_LOADING_ITEM, payload: item });

export const setError = (type, error = '') => ({ type: SET_ERROR_ITEM, payload: { type, error } });
export const removeError = (item) => ({ type: REMOVE_ERROR_ITEM, payload: item });

export const setCommonData = (data) => ({ type: SET_COMMON_DATA, payload: data });
export const clearError = (errorKey) => ({
  type: REMOVE_ERROR_ITEM,
  payload: errorKey,
});

export const setHideBanner = (type = BANNERS.CARD, id = '') => {
  const options = BANNERS_OPTIONS[type] || {};
  const { cookieKey, maxAge } = options;

  if (type === BANNERS.HEADER) {
    const bannerId = String(id);

    Cookie.set(null, cookieKey, bannerId, { maxAge });
    return { type: SET_SHOW_BANNERS, payload: { [type]: bannerId } };
  }
  Cookie.set(null, cookieKey, true, { maxAge });
  return { type: SET_SHOW_BANNERS, payload: { [type]: false } };
};

export const setInitialShowBanners =
  (pathname = '/') =>
  (dispatch, getState) => {
    const {
      common = {},
      settings: { getCtx },
    } = getState();
    const { banner = {} } = common;
    const { description } = banner;
    const ctx = getCtx();

    // показываем баннер нет ключа в куке и есть описание (баннер в шапке показываем не для всех страниц)
    const isHeader =
      !BANNERS_OPTIONS.HEADER.hiddenRoutes.includes(pathname) &&
      !!Cookie.get(ctx, BANNERS_OPTIONS.HEADER.cookieKey) &&
      !!description;
    const isCard = !Cookie.get(ctx, BANNERS_OPTIONS.CARD.cookieKey) && !!description;
    const payload = {
      [BANNERS.HEADER]: isHeader && Cookie.get(ctx, BANNERS_OPTIONS.HEADER.cookieKey),
      [BANNERS.CARD]: isCard,
    };

    return dispatch({ type: SET_SHOW_BANNERS, payload });
  };
